module.exports = __webpack_public_path__ + "static/media/aircon-icon.f26151d2.svg";